import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useOfferingCatalog } from '@/hooks/useOfferingCatalog';

interface Props {
  value: string[];
  onChange: (v: string[]) => void;
}

export function QualifyStepOfferings({ value, onChange }: Props) {
  const { groups, isLoading } = useOfferingCatalog();

  const toggle = (key: string) => {
    onChange(
      value.includes(key) ? value.filter((k) => k !== key) : [...value, key]
    );
  };

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 py-8 text-sm text-muted-foreground justify-center">
        <Loader2 className="h-4 w-4 animate-spin" />
        Laddar…
      </div>
    );
  }

  // Flatten all types into a simple chip selector for the qualify flow
  const allTypes = groups.flatMap((g) => g.types);

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="font-display text-xl text-foreground">Vad kan människor göra hos dig?</h2>
        <p className="text-sm text-muted-foreground">
          Välj allt som passar. Du kan ändra senare.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        {allTypes.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => toggle(t.key)}
            className={cn(
              'px-4 py-2.5 rounded-full border text-sm transition-colors',
              value.includes(t.key)
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-border text-muted-foreground hover:border-foreground/30'
            )}
          >
            {t.label_sv}
          </button>
        ))}
      </div>
    </div>
  );
}
